import { FC } from 'react';
import { css } from '@emotion/react';
import { Users, EnvelopeSimpleOpen } from '@phosphor-icons/react';
import { Banner } from 'client/components/Banner';
import { DialogContent } from 'client/components/Dialog/DialogContent';
import { useGitHubLogin } from 'client/components/GitHub/useGitHubLogin';
import { Modal } from 'client/components/Layout/Modal';
import { LoginWithGitHubButton } from '../components/LoginWithGitHubButton';

const bannerStyle = css`
  margin-top: 16px;
`;

export interface PilotInviteProps {
  token: string;
}

export const PilotInvite: FC<PilotInviteProps> = ({ token }) => {
  const { login, isLoading: isGithubLoading, isError: isGithubError } = useGitHubLogin();

  return (
    <Modal>
      <DialogContent
        title="Sign Up"
        description="You have been invited to try out Diploi"
        icon={<Users />}
        iconOrnament={<EnvelopeSimpleOpen />}
        actions={null}
        dismissable={false}
      >
        <LoginWithGitHubButton title="Sign Up with GitHub" loading={isGithubLoading} onClick={() => login({ token })} />
        <Banner css={bannerStyle}>
          You will be registered to use Diploi with your GitHub account. Use the same account to login in the future.
        </Banner>
      </DialogContent>
    </Modal>
  );
};
